
export const getTranslatedText = (text) => {
    if(window && window.LocalizationConfig && window.LocalizationConfig.strings && window.LocalizationConfig.strings[text]){
        const translatedString = String(window.LocalizationConfig.strings[text])
        const value = translatedString.split('|')[0] || translatedString
        return  value
    }
    return text
}


export default  getTranslatedText
